<td (click)="onSelect()">
  <small
    class="tw-block tw-font-medium !tw-flex-center !tw-pt-[2px] !tw-pr-[1px] !tw-text-[12px] tw-w-[18px] tw-h-[18px] tw-rounded-full"
    [ngClass]="{
      'tw-bg-sky-100/90 dark:tw-bg-sky-400/10 tw-text-sky-500': level==1,
      'tw-bg-orange-100/90 dark:tw-bg-orange-400/10 tw-text-orange-500':level==2,
      'tw-bg-pink-100/90 dark:tw-bg-pink-400/10 tw-text-pink-500': level==3,
      'tw-bg-purple-100/90 dark:tw-bg-purple-400/10 tw-text-purple-500':level==4,
      'tw-bg-teal-100/90 dark:tw-bg-teal-400/10 tw-text-teal-500':level==5,
    }"
  >
    {{ level }}</small
  >
</td>
<td>
  <!-- *checkbox -->
  <phonebook-row-checkbox
    *ngIf="phonebook?.subItems?.length"
    class="tw-py-3"
    [value]="isCheckedAllSubItems()"
    [indeterminate]="isCheckedSomeSubItems()"
    (valueChange)="onCheckSubItems($event)"
  ></phonebook-row-checkbox>
</td>
<td
  colspan="3"
  class="dir-rtl tw-w-full"
  style="padding: 0px 0.5rem !important"
>
  <div class="tw-flex tw-items-center">
    <div
      class="tw-py-3"
      [style.padding-right.px]="paddingR"
      [class]="isShowInputs ? 'vertical-line-sm' : 'vertical-line'"
    ></div>

    <!-- *btn -->
    <phonebook-row-btn
      *ngIf="isShowParentBtn"
      [isOpen]="isOpen"
      [loading]="loading"
      [isZero]="this.phonebook.subItems === null"
      (btnClick)="getPhonebooksByParentIdApi()"
    ></phonebook-row-btn>
    <!-- *checkbox -->
    <phonebook-row-checkbox
      class="tw-py-3"
      [(value)]="phonebook.checked"
      (valueChange)="onChecked($event)"
    ></phonebook-row-checkbox>
    <!-- *name -->
    <phonebook-row-name
      class="tw-flex-1 tw-py-3"
      (click)="onSelect()"
      [phonebookName]="phonebook?.name"
    ></phonebook-row-name>
  </div>
</td>

<!-- *phonebookType -->
<td class="tw-px-1">
  <span [phoneBookTypeStyle]="phonebook?.phonebookTypes">
    {{ phonebook?.phonebookTypes | enumToText : PhonebookTypesEnumValues }}
  </span>
</td>

<!-- *contactsCount -->
<td class="tw-p-0 tw-cursor-pointer" (click)="onSelect()">
  <td-value
    fontSize="md"
    type="number"
    [attr.data-phonebook-contacts-count-id]="phonebook.id"
    [value]="phonebook?.contactsCount"
  >
  </td-value>
</td>

<!-- *parentName -->
@if(isShowParentName){
<td class="tw-p-0 tw-cursor-pointer" (click)="onSelect()">
  <td-value
    class="tw-block tw-w-[50px]"
    fontSize="md"
    type="text"
    [value]="phonebook?.parentName"
  >
  </td-value>
</td>
}

<!-- *from index to index inputs -->
@if(isShowInputs){
<!--^ fromIndex -->
<td class="tw-px-0 tw-py-2" (click)="onSelect()">
  <phonebook-row-input
    [disabled]="phonebook.contactsCount == 0"
    [max]="phonebook?.contactsCount"
    [checked]="phonebook.checked"
    [isValid]="phonebook.isValid"
    [(value)]="phonebook.fromIndex"
    (valueChange)="handleValidation()"
  >
  </phonebook-row-input>
</td>
<!--^ count -->
<td class="tw-px-0" (click)="onSelect()">
  <phonebook-row-input
    [disabled]="phonebook.contactsCount == 0"
    [max]="phonebook?.contactsCount"
    [checked]="phonebook.checked"
    [isValid]="phonebook.isValid"
    [(value)]="phonebook.count"
    (valueChange)="handleValidation()"
  >
  </phonebook-row-input>
</td>
} @if(isShowFullTable){
<!-- *whiteMessageId -->
<td class="tw-p-0 tw-cursor-pointer" (click)="onSelect()">
  <td-value fontSize="md" [value]="phonebook?.whiteMessageId"> </td-value>
</td>
<!-- *created -->
<td class="tw-cursor-pointer" (click)="onSelect()">
  <td-value fontSize="md" type="date" [value]="phonebook?.created"></td-value>
</td>
<!-- *operation btns -->
<td>
  <phonebook-row-menu
    [item]="phonebook"
    [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
    (operation)="onOperation($event)"
  >
  </phonebook-row-menu>
</td>
}
